import { render, staticRenderFns } from "./headofficeDashboard.vue?vue&type=template&id=13142c82&scoped=true&"
import script from "./headofficeDashboard.vue?vue&type=script&lang=js&"
export * from "./headofficeDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13142c82",
  null
  
)

export default component.exports